import React from 'react';
import { Spinner } from 'dibs-elements/exports/Spinner';

import styles from './LoadingSpinner.scss';

export function LoadingSpinner() {
    return (
        <div className={styles.wrapper}>
            <div className={styles.spinnerContainer}>
                <Spinner />
            </div>
        </div>
    );
}
